<template>
  <div id="app" v-cloak>
    <!-- <AppHeader></AppHeader> -->
    <router-view />
  </div>
</template>

<script>
import AppHeader from '../header/AppHeader'
import applicationConstants from '@/constants/ApplicationConstants'

export default {
  name: 'App',
  components: { AppHeader },
  created () {
  },
  mounted () {
    if (applicationConstants.enableChatBox) {
      let script = document.createElement('script')
      script.setAttribute('type', 'text/javascript')
      script.innerHTML = `(function(){var w=window;var ic=w.Intercom;if(typeof ic==="function"){ic('reattach_activator');ic('update',w.intercomSettings);}else{var d=document;var i=function(){i.c(arguments);};i.q=[];i.c=function(args){i.q.push(args);};w.Intercom=i;var l=function(){var s=d.createElement('script');s.type='text/javascript';s.async=true;s.src='https://widget.intercom.io/widget/${applicationConstants.intercomAppId}';var x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s,x);};if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}}})();`
      document.head.appendChild(script)

      window.Intercom('boot', {
        app_id: applicationConstants.intercomAppId
      })
      window.Intercom('update')
    }
  }
}
</script>

<style src="../../../static/css/common.css"></style>
<style>
[v-cloak] > * { display:none }
[v-cloak]::before { content: "loading…" }
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/components/main/App.vue